import { Box } from '@mui/material'
import { useAppSelector } from '../../app/hooks'
import { useGetUserTypesQuery } from '../../app/redux-fetch/apiQuery'
import FormInput from '../../components/Forms/FormInput'
import FormPhoneInput from '../../components/Forms/FormPhoneInput'
import FormSelect from '../../components/Forms/FormSelect'
import { SectionTitleTypography } from '../../components/Typographies/styles'
import { fetchLoggedInUserSelector } from '../selectors'
import { ILoggedInUser } from '../types'
import { useWorkforceFormContext } from './hooks/useWorkforceFormContext'

type UserInfoProps = {
    isDisabled?: boolean
    isNew: boolean
}

const UserInfo = ({ isDisabled = false, isNew }: UserInfoProps) => {
    const { setValue } = useWorkforceFormContext()

    const { tenantId } = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)

    const { data: userTypes } = useGetUserTypesQuery({
        tenantId
    })

    const userTypeOptions = userTypes
        ? userTypes
            .filter(x => x.id > 1)
            .map(userType => ({
                label: userType.name,
                value: userType.id
            }))
        : []


    return (
        <Box>
            <Box sx={{ mb: '16px' }}>
                <SectionTitleTypography>Workforce Info</SectionTitleTypography>
            </Box>

            <FormSelect
                name="userTypeId"
                label="Workforce Type"
                options={userTypeOptions}
                required
                disabled={isDisabled || !isNew}
                onChange={(event) => {
                    const selectedValue = Number(event.target.value)
                    const selectedUserType = userTypes?.find(x => x.id === selectedValue)
                    setValue('driverDetail', undefined)
                    setValue('userType', {
                        id: selectedValue,
                        name: selectedUserType?.name ?? ''
                    })
                }}
            />

            <FormInput
                name="firstName"
                label="First Name"
                required
                disabled={isDisabled}
                maxLength={150}
            />

            <FormInput
                name="lastName"
                label="Last Name"
                required
                disabled={isDisabled}
                maxLength={150}
            />

            <FormInput
                name="email"
                label="Email"
                type="email"
                required
                disabled={isDisabled}
                maxLength={250}
            />

            <FormPhoneInput
                name="phone"
                label="Phone"
                required
                disabled={isDisabled}
                maxLength={15}
            />
        </Box>
    )
}

export default UserInfo
